import { FilterCampionarioProduzione, GruppoLavorazioniPerConsegna, GruppoLavorazioniPerFase, GruppoLavorazioniPerLotto, GruppoLavorazioniPerStagione, TextValueItem } from '@/models';
import {
  Utente,
  LavorazioneSlim,
  StatoLavorazione,
  Lavorazione,
  MessaggioNotifica,
  Ordine,
  OrdineSlim,
  Azione,
  AzioniLavorazione,
  LavorazionePerSpedizione,
  Spedizione,
  DatiLookup,
  Distinta,
  GruppoVenduto,
  Reintegro,
  GruppoDistinte,
  OrdineMTMTestata,
  OrdineMTM
} from '@/models';
import { OrdineSpacchettatoDettaglio } from '@/models/OrdineSpacchettatoDettaglio';
import { OrdineSpacchettatoLista } from '@/models/OrdineSpacchettatoLista';
import { OrdineSpacchettatoTestata } from '@/models/OrdineSpacchettatoTestata';
import { StatoSpedizione } from '@/models/enums/StatoSpedizioni';

export enum ApplicationState {
  "Working" = "working",
  "NetworkError" = "networkError",
  "Initialization" = "initialization",
  "FatalError" = "fatalError"
};

export interface FiltriOrdini {
  numOrdine: string;
  mostraCompletati: boolean;
  soloUSA: boolean;
  campionarioEProduzione: FilterCampionarioProduzione;
  filtroModelli: string[];
  filtroStagioni: string[];
  filtroFasi: string[];
  filtroPartita: string;
}

export interface FiltriOrdiniMTM {
  nominativoCliente: string;
  idCliente: string;
  numeroOrdine: string;
  stato: string;
  dataConsegnaDa: string;
  dataConsegnaA: string;
  rigaDataConsegnaFornitoreDa: string;
  rigaDataConsegnaFornitoreA: string;
  rigaDataChiusuraConsegnaDa: string;
  rigaDataChiusuraConsegnaA: string;
  filtroModelli: string[];
  filtroStagioni: string[];
}

export interface FiltriLavorazioni {
  numOrdine: string;
  mostraCompletati: boolean;
  codLAK: string;
  lotto: string;
  soloUSA: boolean;
  soloConNote: boolean;
  campionarioEProduzione: FilterCampionarioProduzione;
  filtroModelli: string[];
  filtroStagioni: string[];
  filtroFasi: string[];
  filtroConsegne?: string[];
}

export interface FiltriSpedizioni {
  numSpedizione: string,
  dataSpedizioneDa: string,
  dataSpedizioneA: string
}

export interface FiltriReintegri {
  idDistintaStatica: string,
  dataInserimentoDa: string,
  dataInserimentoA: string
}

export interface FiltriDistinteStatiche{
  idFornitore: string;
  soloDistinteDaValidare: boolean;
  soloDistinteInDraft: boolean;
  soloDistinteValidateESincronizzate: boolean;
  filtroStagioni: string[];
  filtroColori: string[];
  filtroModelli: string[];
  filtroLineeVendita: string[];
  filtroAvanzamentiProduzione: string[];
  filtroVariazioniDaData?: Date;
  filtroVariazioniAData?: Date;
}

export interface RootState {
  appState: ApplicationState;
  currentUsr?: any;
  loading: boolean;
  errori: MessaggioNotifica[];
  fornitori: Utente[];
  fornitore?: Utente;
  datiLookup?: DatiLookup;
  listaOrdini: OrdineSlim[];
  listaOrdiniMTM: OrdineMTMTestata[];
  listaReintegri: Reintegro[];
  reintegroCorrente?: Reintegro;
  ordineCorrente?: Ordine;
  modelliSchedeCorrenti: string[];
  ordineMTMCorrente?: OrdineMTM;
  ordineSpacchettatoTestata?: OrdineSpacchettatoTestata;
  ordineSpacchettatoLista?: OrdineSpacchettatoLista[];
  ordineSpacchettatoDettaglio?: OrdineSpacchettatoDettaglio[];
  gruppoLavorazioni: Lavorazione[];
  listaLavorazioni: LavorazioneSlim[];
  listaLavorazioniSelezionate: LavorazioneSlim[];
  lavorazioneCorrente?: Lavorazione;
  azioniLavorazioni: AzioniLavorazione[];
  lavorazioniPerSpedizione: LavorazionePerSpedizione[];
  spedizioneCorrente?: Spedizione;

  listaSpedizioni: Spedizione[],
  distintaCorrente?: Distinta,

  stampaEtichetteRfidDisponibile: boolean;
  stampaEtichetteNoRfidDisponibile: boolean;

  ui: {
    azioniVisibili: boolean;
    opzioniVisibili: boolean;
    titoloPagina: string;
    sottotitoloPagina: string;
    dimensionePaginaListe: number;
  };

  uiOrdiniMTM: {
    pagina: number;
    totPagine: number;
    totOrdini: number;
    listView: boolean;
    downloadButtonLoading: number;
    idRiga: string | undefined | null;
    idLidAssociata: string | undefined | null;
    filtri: FiltriOrdiniMTM;
  },
  uiOrdine:{
    isSchedaTecnicaDownloading: boolean;

    stampaEtichette:{
      loadingOperazioniDisponibili: boolean;
      stampaDisponibile: boolean;
      resetEpcDisponibile: boolean;
      loading: boolean;
    }
  },
  uiOrdini: {
    pagina: number;
    totPagine: number;
    totOrdini: number;
    listView: boolean;
    filtri: FiltriOrdini;
    downloadButtonLoading: boolean;
  },
  uiReintegri: {
    pagina: number;
    totPagine: number;
    totReintegri: number;
    listView: boolean;
    csvButtonLoading: boolean;
    filtri: FiltriReintegri;
  },
  uiLavorazioni: {
    pagina: number;
    totPagine: number;
    totLavorazioni: number;
    listView: boolean;
    filtroStatoOrdini: StatoLavorazione[];
    filtri: FiltriLavorazioni;
  },

  uiLavorazione: {
    azioni: Azione[];
    csvButtonLoading: boolean,
    xlsxPackingListLavorazioneLoading: boolean,
    xlsxPackingListLavorazioneSpacchettatoLoading: string[],
    xlsxPackingListOrdineLoading: boolean,
    stampaEtichette: {
      loading: boolean,
      loadingOperazioniDisponibili: boolean,
      stampaDisponibile: boolean,
      resetEpcDisponibile: boolean,
      indiceTaglia: string,
      etichetta: string,
    }
  },
  uiSpedizioni: {
    pagina: number,
    totPagine: number;
    totSpedizioni: number;
    listView: boolean,
    idSpedizioneForDelete: string | null | undefined,
    filtroStato: StatoSpedizione | undefined,
    filtri: FiltriSpedizioni
  },
  uiSpedizione: {
    lavorazionePerAggiuntaRiga: LavorazioneSlim,
    loading: boolean
    csvLoading: boolean
  },
  uiConsumi: {
    pagina: number;
    totPagine: number;
    totItems: number;
    listaDistinteCorrelate: Distinta[]; // lista delle distinte relative allo stesso modello in editing, usata per variazioni massive
    listaGruppiDistinte: GruppoDistinte[];
    filtriDistinte: FiltriDistinteStatiche;
  };
  uiVenduto: {
    pagina: number,
    totPagine: number,
    totItems: number,
    items: GruppoVenduto[],
    fornitore: undefined,
    csvButtonLoading: boolean;
    stagione: undefined
  };
  uiGruppoLavorazioniPerStagione:{
    pagina: number;
    totPagine: number;
    totGruppi: number;
    loadingGruppoLavorazioniPerStagione: boolean;
    gruppoLavorazioniPerStagione: GruppoLavorazioniPerStagione[];
    dimensionePaginaListe: number
  },
  uiGruppoLavorazioniPerStagioneDataSource:{
    dataSourceStagioni: TextValueItem[];
  },
  uiGruppoLavorazioniPerFase:{
    pagina: number;
    totPagine: number;
    totGruppi: number;
    loadingGruppoLavorazioniPerFase: boolean;
    gruppoLavorazioniPerFase: GruppoLavorazioniPerFase[];
    dimensionePaginaListe: number
  },
  uiGruppoLavorazioniPerFaseDataSource:{
    dataSourceFasi: TextValueItem[];
    dataSourceStagioni: TextValueItem[];
  },
  uiGruppoLavorazioniPerConsegna:{
    pagina: number;
    totPagine: number;
    totGruppi: number;
    loadingGruppoLavorazioniPerConsegna: boolean;
    gruppoLavorazioniPerConsegna: GruppoLavorazioniPerConsegna[];
    dimensionePaginaListe: number
  },
  uiGruppoLavorazioniPerConsegnaDataSource:{
    dataSourceConsegne: TextValueItem[];
    dataSourceStagioni: TextValueItem[];
  },
  uiGruppoLavorazioniPerLotto:{
    pagina: number;
    totPagine: number;
    totGruppi: number;
    loadingGruppoLavorazioniPerLotto: boolean;
    gruppoLavorazioniPerLotto: GruppoLavorazioniPerLotto[];
    dimensionePaginaListe: number
  },
  uiGruppoLavorazioniPerLottoDataSource:{
    dataSourceLotti: TextValueItem[];
    dataSourceStagioni: TextValueItem[];
  }
}

export const initialState: RootState = {
  appState: ApplicationState.Initialization,
  currentUsr: undefined,
  loading: false,
  errori: [],
  fornitori: [],
  fornitore: undefined,
  datiLookup: undefined,
  listaOrdini: [],
  listaOrdiniMTM: [],
  ordineCorrente: undefined,
  ordineMTMCorrente: undefined,
  ordineSpacchettatoTestata: undefined,
  ordineSpacchettatoLista: [],
  ordineSpacchettatoDettaglio: [],
  modelliSchedeCorrenti: [],
  listaLavorazioni: [],
  listaLavorazioniSelezionate: [],
  lavorazioneCorrente: undefined,
  gruppoLavorazioni: [],
  azioniLavorazioni: [],
  lavorazioniPerSpedizione: [],
  spedizioneCorrente: undefined,
  listaSpedizioni: [],
  distintaCorrente: undefined,
  listaReintegri: [],
  reintegroCorrente: undefined,
  stampaEtichetteNoRfidDisponibile: false,
  stampaEtichetteRfidDisponibile: false,
  ui: {
    azioniVisibili: false,
    opzioniVisibili: false,
    titoloPagina: "Filolog",
    sottotitoloPagina: "",
    dimensionePaginaListe: 12
  },
  uiOrdine:{
    isSchedaTecnicaDownloading: false,
    stampaEtichette:{
      loadingOperazioniDisponibili: false,
      stampaDisponibile: false,
      resetEpcDisponibile: false,
      loading: false,
    }
  },
  uiOrdiniMTM: {
    pagina: 1,
    totPagine: 0,
    totOrdini: 0,
    listView: true,
    downloadButtonLoading: 0,
    idRiga: null,
    idLidAssociata: null,
    filtri: {
      numeroOrdine: '',
      nominativoCliente: '',
      idCliente: '',
      dataConsegnaA: '',
      dataConsegnaDa: '',
      stato: '',
      rigaDataChiusuraConsegnaA: '',
      rigaDataChiusuraConsegnaDa: '',
      rigaDataConsegnaFornitoreA: '',
      rigaDataConsegnaFornitoreDa: '',
      filtroModelli: [],
      filtroStagioni: [],
    
    }
  },
  uiOrdini: {
    pagina: 1,
    totPagine: 0,
    totOrdini: 0,
    listView: true,
    downloadButtonLoading: false,
    filtri: {
      numOrdine: '',
      soloUSA: false,
      campionarioEProduzione: FilterCampionarioProduzione.CampionarioEProduzione,
      mostraCompletati: false,
      filtroModelli: [],
      filtroStagioni: [],
      filtroFasi: [],
      filtroPartita: "",
    }
  },
  uiReintegri: {
    pagina: 1,
    totPagine: 0,
    totReintegri: 0,
    csvButtonLoading: false,
    listView: true,
    filtri: {
      idDistintaStatica: '',
      dataInserimentoDa: '',
      dataInserimentoA: '',
    }
  },
  uiLavorazioni: {
    pagina: 1,
    totPagine: 0,
    totLavorazioni: 0,
    listView: true,
    filtroStatoOrdini: [StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE],
    filtri: {
      numOrdine: '',
      codLAK: '',
      lotto: '',
      mostraCompletati: false,
      soloUSA: false,
      soloConNote: false,
      campionarioEProduzione: FilterCampionarioProduzione.CampionarioEProduzione,
      filtroModelli: [],
      filtroStagioni: [],
      filtroFasi: [],
      filtroConsegne: []
    }
  },
  uiLavorazione: {
    azioni: [],
    csvButtonLoading: false,
    xlsxPackingListLavorazioneLoading: false,
    xlsxPackingListLavorazioneSpacchettatoLoading: [],
    xlsxPackingListOrdineLoading: false,
    stampaEtichette:{
      etichetta: "",
      loadingOperazioniDisponibili: false,
      stampaDisponibile: false,
      resetEpcDisponibile: false,
      indiceTaglia: "",
      loading: false,
    }
  },
  uiSpedizioni: {
    pagina: 1,
    totPagine: 0,
    totSpedizioni: 0,
    listView: true,
    idSpedizioneForDelete: undefined,
    filtroStato: undefined,
    filtri: {
      numSpedizione: '',
      dataSpedizioneDa: '',
      dataSpedizioneA: '',
    }
  },
  uiSpedizione: {
    lavorazionePerAggiuntaRiga: {} as LavorazioneSlim,
    loading: false,
    csvLoading:false,
  },
  uiConsumi: {
    pagina: 1,
    totPagine: 0,
    totItems: 0,
    listaDistinteCorrelate: [],
    listaGruppiDistinte: [],
    filtriDistinte: {
      soloDistinteValidateESincronizzate: false,
      filtroAvanzamentiProduzione: [],
      filtroColori:[],
      filtroModelli:[],
      filtroStagioni:[],
      filtroLineeVendita:[],
      idFornitore: "",
      soloDistinteDaValidare:false,
      soloDistinteInDraft:false,
    }
  },
  uiVenduto: {
    pagina: 1,
    totPagine: 0,
    totItems: 0,
    items: [],
    fornitore: undefined,
    stagione: undefined,
    csvButtonLoading: false
  },
  uiGruppoLavorazioniPerStagione:{
    pagina: 1,
    totPagine: 0,
    totGruppi: 0,
    loadingGruppoLavorazioniPerStagione: false,
    gruppoLavorazioniPerStagione: [],
    dimensionePaginaListe: 36
  },
  uiGruppoLavorazioniPerStagioneDataSource:{
    dataSourceStagioni: []
  },
  uiGruppoLavorazioniPerFase:{
    pagina: 1,
    totPagine: 0,
    totGruppi: 0,
    loadingGruppoLavorazioniPerFase: false,
    gruppoLavorazioniPerFase: [],
    dimensionePaginaListe: 36
  },
  uiGruppoLavorazioniPerFaseDataSource:{
    dataSourceFasi: [],
    dataSourceStagioni: []
  },
  uiGruppoLavorazioniPerConsegna:{
    pagina: 1,
    totPagine: 0,
    totGruppi: 0,
    loadingGruppoLavorazioniPerConsegna: false,
    gruppoLavorazioniPerConsegna: [],
    dimensionePaginaListe: 36
  },
  uiGruppoLavorazioniPerConsegnaDataSource:{
    dataSourceConsegne: [],
    dataSourceStagioni: []
  },
  uiGruppoLavorazioniPerLotto:{
    pagina: 1,
    totPagine: 0,
    totGruppi: 0,
    loadingGruppoLavorazioniPerLotto: false,
    gruppoLavorazioniPerLotto: [],
    dimensionePaginaListe: 36
  },
  uiGruppoLavorazioniPerLottoDataSource:{
    dataSourceLotti: [],
    dataSourceStagioni: []
  }
}